'use client'
import { styled } from '../config'

export const Grid = styled('div', {
  display: 'grid',
})
